var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ good: this.type == 'good', warning: this.type == 'warning', bad: this.type == 'bad' }},[_c('h1',{attrs:{"id":"icon"}},[_vm._v(_vm._s(_vm.getIcon))])])}
var staticRenderFns = []

export { render, staticRenderFns }